const hsInstanceId = process.env.NEXT_PUBLIC_HUBSPOT_INSTANCE_ID;
const hsLeadEvent = 'pe' + hsInstanceId + '_lead_tracked';

export const identifyHubspotLead = (leadEmail: string) => {
  if (!leadEmail) {
    return;
  }

  if (!hsInstanceId) {
    console.error('NEXT_PUBLIC_HUBSPOT_INSTANCE_ID is not defined');
    return;
  }

  const _hsq = (window._hsq = window._hsq || []);
  _hsq.push([
    'identify',
    {
      email: leadEmail,
    },
  ]);
  _hsq.push([
    'trackCustomBehavioralEvent',
    {
      name: hsLeadEvent,
      properties: {
        web_tracking: 1,
      },
    },
  ]);
};

export function cleanUrlPath(path?: string): string {
  if (path) {
    const trimmed = path?.replace(/^\/|\/$/g, ''); // Remove leading/trailing slashes

    return trimmed === '' ? 'home' : trimmed;
  }
  return '';
}
